export default "__VITE_ASSET__BrVmMHuU__"